import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default function BlogCarouselBlock({ data }) {
  const { images = [], fullWidth = false, rounded = true, showCaptions = true, visibleItems } = data;
  if (!images.length) return null;

  // Modo ancho completo: una foto por slide con su pie debajo.
  // Modo normal: respeta "visibleItems" (1/2/3), con el comportamiento previo por defecto.
  const perView = fullWidth ? 1 : (visibleItems || 1.2);
  const breakpoints = fullWidth
    ? undefined
    : {
        768: { slidesPerView: visibleItems || 2.2, spaceBetween: 20 },
        1024: { slidesPerView: visibleItems || 2.5, spaceBetween: 24 },
      };

  const blockClass = [
    'blog-carousel-block',
    fullWidth ? 'blog-carousel-block--full' : '',
    rounded ? '' : 'blog-carousel-block--flat',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={blockClass}>
      <Swiper
        modules={[Navigation]}
        navigation
        slidesPerView={perView}
        spaceBetween={fullWidth ? 0 : 16}
        grabCursor
        speed={600}
        breakpoints={breakpoints}
        className="blog-carousel-swiper"
      >
        {images.map((img, i) => (
          <SwiperSlide key={i}>
            <div className="blog-carousel-slide">
              <img src={img.src} alt={img.alt || ''} />
              {showCaptions && img.caption && (
                <p className="blog-carousel-caption">{img.caption}</p>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
